import { LoadingDarkIcon } from "@minervaproject/fds";
import { useContext, useEffect, useState } from "react";

import { ForumAPIContext } from "contexts/forum_api_context";
import { useAppSelector } from "hooks/redux_hooks";
import { selectLiveCaptionResource } from "store/selectors/classroom";

function CaptionsDoc() {
  const forumAPI = useContext(ForumAPIContext);
  const captionsDoc = useAppSelector(selectLiveCaptionResource());
  const [resourceUrl, setResourceUrl] = useState("");

  useEffect(() => {
    const fetchCaptionsDocUrl = async () => {
      if (captionsDoc?.id) {
        const url = await forumAPI.getForumDocSignedUrl(captionsDoc?.id, {
          iframed: true,
          noPresence: true,
          darkMode: true,
          noWhitespace: true,
        });
        setResourceUrl(url);
      }
    };
    fetchCaptionsDocUrl();
  }, [forumAPI, captionsDoc?.id]);

  return (
    <div className="flex flex-column w-full h-full">
      {captionsDoc && resourceUrl ? (
        <div className="flex-auto flex flex-column mt3 mb5 mx5">
          <iframe className="w-full h-full" title={captionsDoc.title} src={resourceUrl} />
        </div>
      ) : (
        <LoadingDarkIcon className="absolute-center" data-testid="loading" />
      )}
    </div>
  );
}

export { CaptionsDoc };
